export const FETCH_CATEGORY_API_DATA = "FETCH_CATEGORY_API_DATA";
export const IS_LOADER = "IS_LOADER";
export const RESET_DATA="RESET_DATA"
